import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { officialLicenseGradeService } from "../../_services/officialLicenseGrade.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
}

export const OfficialLicenseGradeAutoComplete = (params: IStandardExtAutocomplete) => {

    function fetchItems() {
        return officialLicenseGradeService
            .dropdown(params.parentId);
    }

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={fetchItems}
            label={"Official Licence Grade Select"} />
    );
}